module.exports = __webpack_public_path__ + "img/BAI_logo.505e387b.svg";